import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

// Matches the backend Numeric(12, 4) column
const TARGET_DECIMAL_PLACES = 4
const TARGET_MAX_VALUE = 99999999.9999

const hasAllowedDecimalPlaces = (value?: number) =>
  value === undefined || new RegExp(`^\\d+(\\.\\d{1,${TARGET_DECIMAL_PLACES}})?$`).test(String(value))

export const usePedigreedTargetValueSchema = () => {
  const { t } = useTranslation('validation')

  return useMemo(
    () =>
      Yup.number()
        .required(t('field_required'))
        .min(0, t('numberLessThanMin', { min: 0 }))
        .max(TARGET_MAX_VALUE)
        .test('decimal-places', t('decimalPlacesExceeded', { max: TARGET_DECIMAL_PLACES }), hasAllowedDecimalPlaces),
    [t],
  )
}
